const stockItems = [
  {
    id: 1,
    categoria: 'procesadores',
    idCategoria: '1',
    marca: 'AMD',
    modelo: 'Ryzen 7',
    descripcion: 'procesador AMD ryzen 7',
    precio: 384,
    img: 'https://www.tranza.com/content/images/thumbs/0011949_amd-ryzen-7-5700g-video-radeon-am4.png',
  },
  {
    id: 2,
    categoria: 'procesadores',
    idCategoria: '1',
    marca: 'AMD',
    modelo: 'Ryzen 9',
    descripcion: 'procesador AMD ryzen 9',
    precio: 524,
    img: 'https://www.tranza.com/content/images/thumbs/0008015_amd-ryzen-9-5900x-am4.jpeg',
  },
  {
    id: 3,
    categoria: 'procesadores',
    idCategoria: '1',
    marca: 'Intel',
    modelo: 'i3',
    descripcion: 'procesador intel i3',
    precio: 175,
    img: 'https://thotcomputacion.com.uy/wp-content/uploads/2020/07/procesador-intel-core-i3-10ma-generacion-diginet-D_NQ_NP_843853-MLU42770096830_072020-F.jpg',
  },
  {
    id: 4,
    categoria: 'procesadores',
    idCategoria: '1',
    marca: 'Intel',
    modelo: 'i5',
    descripcion: 'procesador intel i5',
    precio: 259,
    img: 'https://m.media-amazon.com/images/I/61xAzEoCuhL._AC_SX466_.jpg',
  },
  {
    id: 5,
    categoria: 'procesadores',
    idCategoria: '1',
    marca: 'Intel',
    modelo: 'i7',
    descripcion: 'procesador intel i7',
    precio: 466,
    img: 'https://media.ldlc.com/r1600/ld/products/00/05/66/86/LD0005668676_2.jpg',
  },
  {
    id: 6,
    categoria: 'motherboards',
    idCategoria: '2',
    marca: 'GygaByte',
    modelo: 'Z390',
    descripcion: 'Tarjeta Madre AsRock Z390',
    precio: 250,
    img: 'https://m.media-amazon.com/images/I/71hmU4YEp+L._AC_SL1500_.jpg',
  },
  {
    id: 7,
    categoria: 'motherboards',
    idCategoria: '2',
    marca: 'asrock',
    modelo: 'Z590',
    descripcion: 'Tarjeta Madre AsRock Z590',
    precio: 640,
    img: 'https://m.media-amazon.com/images/I/81YrnNaeB2L._AC_SL1500_.jpg',
  },
  {
    id: 8,
    categoria: 'memorias',
    idCategoria: '3',
    marca: 'Corsair',
    modelo: 'Vengeance RGB PRO 32GB',
    descripcion: 'Memoria Ram Vengeance RGB Pro 32GB',
    precio: 150,
    img: 'https://m.media-amazon.com/images/I/61zOvMQfqkS._AC_SL1303_.jpg',
  },
  {
    id: 9,
    categoria: 'memorias',
    idCategoria: '3',
    marca: 'KingStone',
    modelo: 'Fury Beast 32gb',
    descripcion: 'Memoria Ram Kingstone Fury Beast 32GB',
    precio: 145,
    img: 'https://m.media-amazon.com/images/I/61oEJKUZd+L._AC_SL1200_.jpg',
  },
  {
    id: 10,
    categoria: 'ssd',
    idCategoria: '4',
    marca: 'SanDisk',
    modelo: '1 TB Extreme Portable',
    descripcion: 'External Solid State Drive SanDisk 1TB Extreme Portable',
    precio: 135,
    img: 'https://m.media-amazon.com/images/I/81gHMgXQybL._AC_SL1500_.jpg',
  },
  {
    id: 11,
    categoria: 'ssd',
    idCategoria: '4',
    marca: 'KingStone',
    modelo: 'Digital SA1000M M.2 240GB',
    descripcion: 'Solid State Drive KingStone M2 Digital SA1000M 240GB',
    precio: 100,
    img: 'https://m.media-amazon.com/images/I/71LCFo1QB7L._AC_SL1500_.jpg',
  },
  {
    id: 12,
    categoria: 'ssd',
    idCategoria: '4',
    marca: 'KingStone',
    modelo: 'KC600 512GB',
    descripcion: 'Solid State Drive KingStone KC600 2.5 512GB',
    precio: 110,
    img: 'https://m.media-amazon.com/images/I/71yn899Q1JL._AC_SL1500_.jpg',
  },
];

export default stockItems;
